import script from "./admin_log.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_log.vue?vue&type=script&setup=true&lang=js"

import "./admin_log.vue?vue&type=style&index=0&id=e78dd824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78dd824"]])

export default __exports__